import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Tab } from '../AttendantTab'
import { updateAttendant } from 'panel/attendant/redux/actions'
import { ApplicationState } from 'AppReducer'
import { passwordValidate } from 'util/services/Validator'

type Props = { onUnsaved: (tab?: Tab) => void }

const initialState = { password: '', _password: '' }
const AttendantPassword: React.FC<Props> = ({ onUnsaved }) => {
  const dispatch = useDispatch()

  const [form, setForm] = useState(initialState)
  const [fetching, setFetching] = useState(false)

  const { id } = useParams<{ id: string }>()

  const { selected } = useSelector((state: ApplicationState) => state.storeReducer)
  const { attendant } = useSelector((state: ApplicationState) => state.attendantReducer)

  async function handleSubmit (e: React.FormEvent): Promise<void> {
    e.preventDefault()

    if (!selected) return undefined

    setFetching(true)
    await updateAttendant(selected, id, form)(dispatch).then(res => {
      if (res?.status === 'success') {
        setForm(initialState)
      }
    })
    setFetching(false)
  }

  // Handle Unsaved form
  useEffect(() => {
    const isUnsaved = JSON.stringify(form) !== JSON.stringify(initialState)
    onUnsaved(isUnsaved ? 'PASSWORD' : undefined)
  }, [form, attendant, initialState])

  const validation = passwordValidate(form.password, form._password)

  return (
    <form className="row margin-top-16 attendant-data" onSubmit={handleSubmit}>
      <div className="row">
        <div className="form-control">
          <label>Senha</label>
          <input
            required={true}
            type="password"
            value={form.password}
            autoComplete="new-password"
            onChange={(e): void => setForm({ ...form, password: e.target.value })}
          />
        </div>

        <div className="form-control">
          <label>Confirmar Senha</label>
          <input
            required={true}
            type="password"
            value={form._password}
            autoComplete="new-password"
            onChange={(e): void => setForm({ ...form, _password: e.target.value })}
          />
        </div>

        <p className="col-12 text-center">{validation.warnings?.[0] || <>&nbsp;</>}</p>
      </div>

      <div className="row margin-top-16 form-buttons">
        <span className="secondary button" onClick={() => setForm(initialState)}>Limpar</span>
        <button className="gradient button" disabled={fetching}>Salvar</button>
      </div>
    </form>
  )
}

export default AttendantPassword
